interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

const buildPages = (page: number, total: number): (number | string)[] => {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages: (number | string)[] = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(total - 1, page + 1);
  if (start > 2) pages.push("...");
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push("...");
  pages.push(total);
  return pages;
};

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = buildPages(page, totalPages);

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className="flex h-9 items-center gap-1 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-3 text-sm text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-200 disabled:hover:text-foreground-600"
      >
        <i className="ri-arrow-left-s-line text-base" />
        上一页
      </button>

      {pages.map((item, index) =>
        typeof item === "number" ? (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            className={`h-9 min-w-[36px] rounded-md px-2 text-sm font-medium transition-colors ${
              item === page
                ? "bg-primary-500 text-background-50"
                : "border border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {item}
          </button>
        ) : (
          <span key={`gap-${index}`} className="px-1 text-sm text-foreground-400">
            {item}
          </span>
        ),
      )}

      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className="flex h-9 items-center gap-1 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-3 text-sm text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-200 disabled:hover:text-foreground-600"
      >
        下一页
        <i className="ri-arrow-right-s-line text-base" />
      </button>
    </nav>
  );
}